import React from "react";
import { Navigate } from "react-router-dom";

import ListComponent from "../../../../../components/container-empty/components/list/page";
import AddComponent from "../../../../../components/extra-container-empty-1/components/add/page";
import VideosComponent from "../../../../../components/container-empty/components/videos/page";

export const extrasEmptyOneRoute = [
  {
    path: "list",
    element: <ListComponent />,
  },
  {
    path: "add",
    element: <AddComponent />,
  },
  {
    path: "videos",
    element: <VideosComponent />,
  },
  {
    path: "edit",
    element: <Navigate to="/extras/empty-one/add" />,
  },
  {
    path: "edit/:id",
    element: <AddComponent />,
  },
  {
    path: "",
    element: <Navigate replace to="/extras/empty-one/add" />,
  },
];
